// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"12aa5c07","533":"f1184019","732":"8b0701dc"}[chunkId] + ".chunk.css";
};